<template>
  <div class="auth-modal">
    <!-- Modal Starts Here -->
    <div
      class="modal fade"
      id="editLocationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editLocationModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <button id="dismissBtnEdit" @click="resetForm()" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                <ion-icon name="ios-close" size="large"></ion-icon>
              </span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 col-md-12 mb-3">
                  <h3 class="title mb-4" v-if="location">Edit {{location.title}}</h3>
                  <h3 class="title mb-4" v-else>Edit Location</h3>
                    <div class="form-group">
                        <GmapMap :center="defaultCoordinates" :options="mapOptions" style="height: 300px">
                            <GmapMarker ref="mapMarker" :position="markerPosition" :clickable="false" :draggable="true" @dragend="markerCallback($event)"/>
                        </GmapMap>
                        <small class="form-text text-muted mb-2">Use the marker to set the circle's location on the map.</small>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="title" class="form-control" placeholder="Location title. (Ex. Infodemics Bariga)"
                            :class="(titleRef.dirty && titleRef.invalid) ? 'touched invalid': ''" />
                    </div>
                    <div class="form-group">
                        <textarea id="description" v-model="description" class="form-control" rows="5"
                            :class="(descRef.dirty && descRef.invalid) ? 'touched invalid': ''"
                            placeholder="Description (Ex. Infodemics Bariga is a chapter of the Nigerian non-profit organization, Infodemics...)"></textarea>
                    </div>
                  <button @click="submit()" id="submitBtnEdit" class="btn btn-block btn-primary text-white" :disabled="!formIsValid">Save Changes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import CircleService from "@/services/circle";
    const circleService = new CircleService();

    export default {
        name: "EditCircleLocation",
        props: ["mapType", "location", "user"],
        data() { 
            return {
                defaultCoordinates: { lat: 9.0748812, lng: 7.465183 },
                markerPosition: { lat: 9.0748812, lng: 7.465183 },
                title: "",
                description: "",
                titleRef: {
                    dirty: false,
                    invalid: true
                },
                descRef: {
                    dirty: false,
                    invalid: true
                },
            }
        },
        computed: {
            mapOptions: function() {
                return {
                    zoom: 7,
                    scrollWheel: false,
                    zoomControl: true,
                    disableDefaultUI: true,
                    scaleControl: false,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeId: this.$props.type || "terrain",
                };
            },
            formIsValid: function() {
                return !this.titleRef.invalid && !this.descRef.invalid;
            }
        },
        watch: {
            title: function(val) {
                this.titleRef.dirty = true;
                if (val === "") {
                    this.titleRef.invalid = true;
                } else {
                    this.titleRef.invalid = false;
                }
            },
            description: function(val) {
                this.descRef.dirty = true;
                if (val === "") {
                    this.descRef.invalid = true;
                } else {
                    this.descRef.invalid = false;
                }
            },
            location: function(val) {
                if (val) {
                    this.defaultCoordinates = { lat: val.latitude, lng: val.longitude };
                    this.markerPosition = { lat: val.latitude, lng: val.longitude };
                    this.title = val.title;
                    this.description = val.description;
                }
            }
        },
        methods: {
            markerCallback(e) {
                this.markerPosition = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            },
            resetForm() {
                this.title = "";
                this.description = "";

                setTimeout(() => {
                    this.titleRef = {
                        dirty: false,
                        invalid: true
                    };
                    this.descRef = {
                        dirty: false,
                        invalid: true
                    };
                }, 1000);

                this.defaultCoordinates = { lat: 9.0748812, lng: 7.465183 },
                this.markerPosition = { lat: 9.0748812, lng: 7.465183 }
            },
            submit() {
                const submit_btn = document.getElementById(`submitBtnEdit`);
                const dismiss_btn = document.getElementById(`dismissBtnEdit`);

                submit_btn.disabled = true;
                submit_btn.innerText = "Saving Changes";
                submit_btn.classList.add("btn--loading");

                const successAction = function() {
                    dismiss_btn.click();
                    submit_btn.innerText = "Save Changes";
                    submit_btn.classList.remove("btn--loading");
                    this.$notification.new("Location modified");
                    this.resetForm();
                }

                const failureAction = function(response) {
                    submit_btn.disabled = false;
                    submit_btn.innerText = "Save Changes";
                    submit_btn.classList.remove("btn--loading");
                    this.$root.$emit("ShowErrorNotification", response.message);
                }

                const obj = {
                    title: this.title,
                    description: this.description,
                    latitude: this.markerPosition.lat,
                    longitude: this.markerPosition.lng,
                    tag: this.$props.location.circle_id,
                    status: "active",
                    profile_id: this.$props.user._id,
                    circle_id: this.$props.location.circle_id,
                    _id: this.$props.location._id
                };

                circleService.editLocation(obj).then((location) => {
                    this.$root.$emit("SaveModifiedCircleLocation", location);
                    successAction.call(this);
                }).catch(err => failureAction.call(this, err));
            }
        },
        mounted() {
            const modal = document.getElementById("editLocationModal");

            const disposeModal = function() {
                if (modal.style.display === 'none') {
                    this.resetForm.call(this);
                }
            };

            modal.addEventListener("blur", disposeModal.bind(this));
        }
    }
</script>


<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>